module.exports = __webpack_public_path__ + "img/Posada-cabo_0001_hotel3.0c9f3ce3.jpg";